import { Injectable } from '@angular/core';
import { RoutesUtilsService } from '@vfde-fe/ngx-lib/services/routes-utils';
import { Route } from '@vfde-fe/ngx-lib/models/route-model';
import { flowMangementConfig } from '../../common/constants/flow-management.defines';
import { FlowId, FlowStep } from '../../models/flow-management.model';
import { forkJoin, Observable , of } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { AppState } from '../../redux/reducers';
import { getPostalShopping, selectCustomerType } from '../../redux/selectors/order-details.selectors';
import findIndex from 'lodash/findIndex';
import reject from 'lodash/reject';
import { filter , map, take } from 'rxjs/operators';
import { getCurrentPersona } from 'src/app/redux/selectors/customer-details.selectors';

/** Class representing FlowManagementService. */
@Injectable()
/** Class representing FlowManagementService. */
export class FlowManagementService {

   /** An observable which holds the customer type. */
    private getCustomerType: Observable<string>;

      /** getNewCustomerType */
      private getNewCustomerType;

      /**
       * Create FlowManagement service.
       * @param  {RoutesUtilsService} routesUtilsService
       * @param  {Store<AppState>} store
       */
    public constructor (private routesUtilsService: RoutesUtilsService, private store: Store<AppState>) {
        this.getCustomerType = this.store.pipe(select(selectCustomerType));
        this.store.pipe(select(getCurrentPersona)).subscribe((persona) => {
                        this.getNewCustomerType = persona;
                    });
    }

     /**
      * Get the flow id from the page-config file.
      * @returns  {string} the flow id
      */
    private loadFlowID (): string {

        const route: Route = this.routesUtilsService.getRouteUsingURL(this.routesUtilsService.getHistoryUrl().currentURL);

        if (route && route.flowManagementID) {

            return route.flowManagementID;
        }

        return null;
    }

    /**
     * Get all the steps after reading the flow id from page-config.
     * @returns  {Observable<FlowStep[]>} the observable which holds the steps array
     */
    public loadSteps (): Observable<FlowStep[]> {

        const flowID: string = this.loadFlowID();

        let steps: FlowStep[] = [];

            if (flowID) {
        /**
         *  Get all the old CustomerType if there is any one of those CustomerType OR -->
         *  Get all the new CustomerType Deer/Fox/Giraffe/Camel if there is any one of those CustomerType
         */
            return forkJoin(this.getCustomerType.pipe(take(1), filter((customerType: string) => !!customerType || !!this.getNewCustomerType)).pipe(
                map((customerType: string) => {

                    customerType = customerType || this.getNewCustomerType;
                    const idValue: FlowId = flowMangementConfig[customerType] && flowMangementConfig[customerType][flowID] ? flowMangementConfig[customerType][flowID] : null;

                    const customizedSteps: FlowStep[] = idValue && idValue.steps && idValue.steps.length ? idValue.steps : [];

                    const isExtended: boolean = idValue && idValue.extend;

                    if (isExtended) {

                        steps = this.filterActons(customizedSteps, this.loadCommonSteps(flowID));
                    } else if (customizedSteps.length) {

                        steps = customizedSteps;
                    }

                    return steps;
                })), this.store.pipe(select(getPostalShopping), take(1))).pipe(map(([steps, isPostalShopping]) => {
                    return reject(steps, step => isPostalShopping && step.hideInPostalShopping) as FlowStep[];
                }));
        } else {

            return of([]);
        }
    }

    /**
     * Get all the steps after reading the flow id from page-config.
     * @param {string} flowID the flow id
     * @returns  {Observable<FlowStep[]>} the observable which holds the steps array
     */
    private loadCommonSteps (flowID: string): FlowStep[] {

        return flowMangementConfig.common && flowMangementConfig.common[flowID]
            && flowMangementConfig.common[flowID].steps ? flowMangementConfig.common[flowID].steps : [];
    }
/** filterActons . */
    public filterActons (customizedSteps: FlowStep[], commonSteps: FlowStep[]): FlowStep[] {

        let index = null;

        const customizedWithNoIds: FlowStep[] = [];

        customizedSteps.forEach((customizedStep: FlowStep) => {

            if (customizedStep.id) {

                index = findIndex(commonSteps, { id: customizedStep.id });

                if (index >= 0) {

                    commonSteps.splice(index, 1, customizedStep);
                } else {

                    commonSteps.push(customizedStep);
                }
            } else {

                customizedWithNoIds.push(customizedStep);
            }
        });

        return customizedWithNoIds.concat(commonSteps);
    }
}
